import { Field as ChakraField } from '@chakra-ui/react';
import * as React from 'react';

export interface FieldProps extends Omit<ChakraField.RootProps, 'label'> {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  errorText?: React.ReactNode;
  optionalText?: React.ReactNode;
  isRequired?: boolean;
}

export const Field = React.forwardRef<HTMLDivElement, FieldProps>(function Field(props, ref) {
  const { label, children, helperText, errorText, ...rest } = props;
  return (
    <ChakraField.Root ref={ref} {...rest}>
      {
        label && (
          <label>
            {label}
            {props?.isRequired && (
              <span
                style={{
                  marginLeft: '10px',
                  backgroundColor: '#E53E3E',
                  color: '#FFFFFF',
                  padding: '3px 6px',
                  borderRadius: '4px',
                  fontSize: '10px'
                }}
              >
                必須
              </span>
            )}
          </label>
        )
      }
      {children}
      {helperText && <ChakraField.HelperText>{helperText}</ChakraField.HelperText>}
      {errorText && <ChakraField.ErrorText>{errorText}</ChakraField.ErrorText>}
    </ChakraField.Root>
  );
});
